import axios from 'axios'
import Cookie from 'js-cookie'
import queryString from '@/utils/queryString'
import os from '@edu-fe/os'
// 控制调用支付接口的次数
let isRequestProcessing = false

async function buy(data, that) {
  const { price, type, goodsId, channel = queryString().channel, issue, frontTradeNo, subject } = data
  const formData = {
    openId: Cookie.get('openid'),
    price: price,
    goodsType: type,
    appType: 1,
    frontTradeNo: frontTradeNo,
    subject: subject,
    goodId: goodsId,
    issue: issue && issue,
    from: 'default',
    cibaId: Cookie.get('openid'),
    appId: window.localStorage.getItem('wkAppId'),
    channel: channel
  }
  !issue && delete formData.issue
  return axios.post('https://chenxi.auoktalk.com/pay/course/platform/pay', formData, {
    'Content-Type': 'multipart/form-data',
    'third-appid': window.localStorage.getItem('wkAppId')
  }).catch(() => {
    that.$toast.show({ message: '支付失败~ 请稍后重试' })
  })
}


function wxPay(params, that) {
  if (!isRequestProcessing) {
    isRequestProcessing = true
    buy(params, that).then(res => {
      if (res.data.code === 0) {
        that.$toast.show({ message: '价格错误' })
      } else if (res.data.code === 1) {
        const data = res.data.data
        window.wx.chooseWXPay({
          ...data,
          timestamp: data.timeStamp,
          success: (res) => {
            if (res.errMsg == 'chooseWXPay:ok') {
              params.succ()
            }
          },
          fail: () => {
            that.$toast.show({ message: '支付失败~ 请稍后重试' })
          }
        })
      } else {
        console.log(res)
        that.$toast.show({ message: res.data.message })
      }

      isRequestProcessing = false
    })
  }

  return null
}

// 购买
export const pay = async (params, that) => {
  // if (os.type === 'weixin') {
  wxPay(params, that)
  // } else {
  // appPay (params)
  // }
}
